<template>
    <v-card>
        <v-tabs v-model="tab" background-color="deep-purple accent-4" centered icons-and-text>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1"> permisos por rol
            </v-tab>

            <v-tab href="#tab-2">permisos por usuario

            </v-tab>


        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
                <v-card flat>
                    <v-card-text>
                        <div class="pa-3">
                            <v-card-title class="flex-nowrap ">
                                <v-icon class="text--primary me-3 ">
                                    {{ icons.mdiKeyOutline }}
                                </v-icon>
                                <span class="text-break">Roles Generales

                                </span>

                            </v-card-title>

                            <v-card-text>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-treeview v-model="selectionRolGeneral" :items="FiltrarRoles(false)"
                                                :selection-type="selectionType" item-children="children" selectable
                                                return-object item-text="descripcion" item-key="id"></v-treeview>
                                        </v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col class="pa-6" cols="6">
                                            <template v-if="!selectionRolGeneral.length"> <span class="error--text">* No
                                                    tiene
                                                    permisos
                                                    seleccionados.</span>
                                            </template>
                                            <template v-else>
                                                <div style=" max-height: 200px; overflow-y: auto;">


                                                    <div v-for="node in selectionRolGeneral" :key="node.id + 'a'">
                                                        {{ node.descripcion }}
                                                    </div>
                                                </div>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card-text>

                            <!-- action buttons -->

                        </div>
                        <v-divider></v-divider>
                        <div class="pa-3">
                            <v-card-title class="flex-nowrap ">
                                <v-icon class="text--primary me-3 ">
                                    {{ icons.mdiKeyOutline }}
                                </v-icon>
                                <span class="text-break">Roles por Puesto

                                </span>

                            </v-card-title>

                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-treeview v-model="selectionRolPuestos" :items="RolesPuestos"
                                            :selection-type="selectionType" item-children="children" selectable
                                            return-object item-text="nombre" item-key="onlyid"></v-treeview>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col class="pa-6" cols="6">
                                        <template v-if="!selectionRolPuestos.length"> <span class="error--text">* No
                                                tiene
                                                permisos
                                                seleccionados.</span>
                                        </template>
                                        <template v-else>
                                            <div style=" max-height: 200px; overflow-y: auto;">


                                                <div v-for="node in selectionRolPuestos" :key="node.onlyid + 'a'">
                                                    {{ node.nombre + ' ' + node.nombreRol }}
                                                </div>
                                            </div>
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <!-- action buttons -->

                        </div>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2">
                <v-card flat>
                    <v-card-text>
                        <div class="pa-3">
                            <v-card-title class="flex-nowrap ">
                                <v-icon class="text--primary me-3 ">
                                    {{ icons.mdiKeyOutline }}
                                </v-icon>
                                <span class="text-break">Permisos Generales

                                </span>

                            </v-card-title>

                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-treeview v-model="selectionPermisosGeneral" :items="FiltrarArboles(-1)"
                                            :selection-type="selectionType" item-children="childrenacciones" selectable
                                            return-object item-text="nombre" item-key="onlyid"></v-treeview>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col class="pa-6" cols="6">
                                        <template v-if="!selectionPermisosGeneral.length"> <span class="error--text">*
                                                No tiene
                                                permisos
                                                seleccionados.</span>
                                        </template>
                                        <template v-else>
                                            <div style=" max-height: 200px; overflow-y: auto;">


                                                <div v-for="node in selectionPermisosGeneral" :key="node.onlyid + 'a'">
                                                    {{ node.nombre + ' ' + node.nombre_modulo }}
                                                </div>
                                            </div>
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <!-- action buttons -->

                        </div>
                        <v-divider></v-divider>
                        <div class="pa-3">
                            <v-card-title class="flex-nowrap ">
                                <v-icon class="text--primary me-3 ">
                                    {{ icons.mdiKeyOutline }}
                                </v-icon>
                                <span class="text-break">Permisos por puesto

                                </span>

                            </v-card-title>

                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-treeview v-model="selectionPermisosPuestos" :items="FiltrarArboles(0)"
                                            :selection-type="selectionType" item-children="childrenacciones" selectable
                                            return-object item-text="nombre" item-key="onlyid"></v-treeview>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col class="pa-6" cols="6">
                                        <template v-if="!selectionPermisosPuestos.length"> <span class="error--text">*
                                                No tiene
                                                permisos
                                                seleccionados.</span>
                                        </template>
                                        <template v-else>
                                            <div style=" max-height: 200px; overflow-y: auto;">


                                                <div v-for="node in selectionPermisosPuestos" :key="node.onlyid + 'b'">
                                                    {{ node.nombre_puesto + ': ' + node.nombre + ' ' +
                                                            node.nombre_modulo
                                                    }}
                                                </div>
                                            </div>
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <!-- action buttons -->

                        </div>
                    </v-card-text>
                </v-card>
            </v-tab-item>

        </v-tabs-items>
        
    </v-card>
</template>
<script>

import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline, mdiCheckboxBlankOutline, mdiCheckboxMarked } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'

export default {
    props: {
        EmpleadoData: Object,
        roles: Array,
        puestos: Array,
        arbol:Array
    },
    setup(props, context) {
        const selectionRolGeneral = ref([])
        const selectionRolPuestos = ref([])
        const selectionPermisosGeneral = ref([])
        const selectionPermisosPuestos = ref([])
        const selection = ref((props.EmpleadoData.empleado.usuario.permisos ? props.EmpleadoData.empleado.usuario.permisos : []))
        const selected = ref([])
        const RolesPuestos = ref([])
        watch(props, () => {
            FiltrarRolesSucursales()
            if (props.EmpleadoData.empleado.id > 0) {
                console.log("EmpleadoData")
                console.log(props.EmpleadoData)
                seleccionarPermisos()
            } 
        })

        watch(selectionRolGeneral, () => {
            context.emit("AsignarPermisos", {
                selectionRolGeneral: selectionRolGeneral.value,
                selectionRolPuestos: selectionRolPuestos.value,
                selectionPermisosGeneral: selectionPermisosGeneral.value,
                selectionPermisosPuestos: selectionPermisosPuestos.value
            });
        })
        watch(selectionRolPuestos, () => {
            context.emit("AsignarPermisos", {
                selectionRolGeneral: selectionRolGeneral.value,
                selectionRolPuestos: selectionRolPuestos.value,
                selectionPermisosGeneral: selectionPermisosGeneral.value,
                selectionPermisosPuestos: selectionPermisosPuestos.value
            });
        })
        watch(selectionPermisosGeneral, () => {
         
            context.emit("AsignarPermisos", {
                selectionRolGeneral: selectionRolGeneral.value,
                selectionRolPuestos: selectionRolPuestos.value,
                selectionPermisosGeneral: selectionPermisosGeneral.value,
                selectionPermisosPuestos: selectionPermisosPuestos.value
            });
        })
        watch(selectionPermisosPuestos, () => {
            context.emit("AsignarPermisos", {
                selectionRolGeneral: selectionRolGeneral.value,
                selectionRolPuestos: selectionRolPuestos.value,
                selectionPermisosGeneral: selectionPermisosGeneral.value,
                selectionPermisosPuestos: selectionPermisosPuestos.value
            });
        })


        const seleccionarPermisos = () => {
            selectionRolGeneral.value = props.EmpleadoData.empleado.usuario.permisos_rol_general
            selectionPermisosGeneral.value = props.EmpleadoData.empleado.usuario.permisos_usuario_general
            selectionPermisosPuestos.value = props.EmpleadoData.empleado.usuario.permisos_usuario_puesto
            selectionRolPuestos.value = props.EmpleadoData.empleado.usuario.permisos_rol_puestos

            console.log(selectionRolGeneral)
            console.log(selectionPermisosGeneral)
            console.log(selectionPermisosPuestos)
            console.log(selectionRolPuestos)
        }


        const FiltrarRolesSucursales = () => {
            let valor = []
            let onlyid = 100000
            FiltrarRoles(true).forEach(element => {
                let puesto = []

                props.puestos.forEach(
                    i => {
                        onlyid += 1
                        puesto.push({ ...i, id_puesto: i.id, onlyid: 'puesto:' + i.id + '-rol:' + element.id, id_rol: element.id, nombreRol: element.descripcion })
                    }
                )
                onlyid += 1
                valor.push({ ...element, onlyid: 'rol:' + element.id, children: [...puesto], nombre: element.descripcion, })
            })


            RolesPuestos.value = valor

            console.log('RolesPuestos')
            console.log(RolesPuestos)
        }

        const mostrarDatos = () => {
            console.log(selectionRolGeneral)
            console.log(selectionPermisosGeneral)
            console.log(selectionPermisosPuestos)
            console.log(selectionRolPuestos)

        }

        const FiltrarRoles = (dato) => {
            const valor = props.roles.filter(item => (item.ind_sucursal == dato))
            if (valor.length > 0) {
                return valor
            }
            return []
        }

        const FiltrarArboles = (tipo_puesto) => {
            const valor = props.arbol.filter(item => (item.id_puesto == tipo_puesto || (tipo_puesto == 0 && item.id_puesto != -1)))
            if (valor.length > 0) {

                if (tipo_puesto == -1) {
                    return valor[0].arbol
                } else {
                    let result = []
                    valor.forEach(i => {
                        result.push({ ...i, childrenacciones: i.arbol })
                    })
                    console.log(result)
                    return result
                }


            }
            return []
        }
        return {
            FiltrarRoles,
            selected,
            icons: {
                mdiKeyOutline,
                mdiLockOpenOutline,
                mdiEyeOffOutline,
                mdiEyeOutline,
                mdiCheckboxBlankOutline,
                mdiCheckboxMarked
            },
            selection,
            selectionType: 'leaf',
            FiltrarArboles,
            store,
            tab: null,
            RolesPuestos,
            selectionRolGeneral,
            selectionPermisosGeneral,
            selectionPermisosPuestos,
            selectionRolPuestos,
            mostrarDatos,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        }
    },
}
</script>